import React from "react";
import { SkipLink, SkipLinkItem } from "mondrian-react";
import messages from "../../components/messages.json";

const links = [
  ["MainContent", "conteudo", "#mdn-MainContent", 1],
  ["Header", "cabecalho", "#mdn-Header", 2],
  ["Footer", "rodape", "#mdn-Footer", 3],
];

export default function AccessibilitySkipLinks() {
  return (
    <div className="cred-SkipLinksHost">
      <SkipLink>
        {links.map(([message, title, href, tabIndex]) => (
          <SkipLinkItem
            className={`cred-SkipLinksAction mdn-SkipLink-Text${message}`}
            href={href}
            key={href}
            tabIndex={tabIndex}
            target="_self"
            title={`Atalhos de acessibilidade: ir-para-${title}`}
          >
            {messages.acessibility[message].text}
          </SkipLinkItem>
        ))}
      </SkipLink>
    </div>
  );
}
